import { render, staticRenderFns } from "./addScheduleSidebar.vue?vue&type=template&id=370191a6&scoped=true&"
import script from "./addScheduleSidebar.vue?vue&type=script&lang=js&"
export * from "./addScheduleSidebar.vue?vue&type=script&lang=js&"
import style0 from "./addScheduleSidebar.vue?vue&type=style&index=0&id=370191a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370191a6",
  null
  
)

export default component.exports